<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="informText != ''">
        <v-alert type="error">{{ informText }}</v-alert>
      </v-col>

      <v-col cols="12">
        <b>Product Code:</b> {{ item.product_code }} - <b>Variant:</b>
        {{ item.variant }} - <b>Current Location:</b>
        {{ item.current_location }}
      </v-col>

      <v-col cols="6">
        <v-select
          :items="listLocationType"
          outlined
          hide-details
          dense
          v-model="newLocationData.new_location_type"
          label="New Location Type"
          @change="loadLocation(newLocationData.new_location_type)"
        ></v-select>
      </v-col>

      <v-col cols="6">
        <v-select
          :items="listLocation"
          :item-text="(obj) => obj.location"
          :item-value="(obj) => obj.location"
          outlined
          hide-details
          dense
          v-model="newLocationData.new_location"
          label="New Location"
        ></v-select>
      </v-col>

      <v-col cols="6">
        <v-text-field
          type="number"
          v-model="newLocationData.quantity"
          hide-details
          dense
          outlined
          label="Quantity"
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          type="number"
          hide-details
          dense
          outlined
          v-model="newLocationData.inbound_outbound_cost"
          label="Inbound Outbound Cost"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="success"
          dark
          @click="saveData()"
          v-if="roles.update_package"
          >Save</v-btn
        >
        <v-btn color="success" disabled v-else>Save</v-btn>
        &nbsp;
        <v-btn color="orange" dark @click="cancelData()">Close</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import Amplify from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "PackageChangeLocation",

  props: {
    item: Object,
    locationData: Array,
    packageID: String,
  },

  data: () => ({
    //productItem: JSON.parse(JSON.stringify(this.item)),
    listLocation: [],
    listLocationType: [],
    newLocationData: {
      unique_product_group_code: "",
      quantity: 0,
      new_location: "",
      new_location_type: "",
      inbound_outbound_cost: 0,
    },
    informText: "",
    roles: [],
  }),

  methods: {
    loadLocationType() {
      var locationType = new Set();
      for (var i of this.locationData) {
        locationType.add(i.location_type);
      }
      this.listLocationType = Array.from(locationType);
    },

    loadLocation(locationType) {
      this.listLocation = this.locationData.filter(
        (t) => t.location_type == locationType
      );
    },

    cancelData(reload) {
      if (reload) {
        this.$root.$refs.packageListDetail.turnOffDialog(true);
      } else {
        this.$root.$refs.packageListDetail.turnOffDialog();
      }
    },

    async saveData() {
      this.newLocationData.unique_product_group_code =
        this.item.unique_product_group_code;

      console.log("newLocationData: ", this.newLocationData);

      var currentSession = await this.$root.$refs.App.currentSession(
        "package-saveData"
      );

      if (currentSession.accessToken) {
        await axios({
          method: "POST",
          url:
            window.domain +
            "packages/change-product-location/" +
            this.packageID,
          headers: { Authorization: currentSession.accessToken },
          data: this.newLocationData,
        }).then((response) => {
          console.log("response: ", response);
          if (response.data.error_message != "") {
            this.informText = response.data.error_message;
          } else {
            this.cancelData(true);
          }
        });
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("package");
    if (this.roles.update_package) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    this.newLocationData.quantity = this.item.in_stock;
    this.loadLocationType();
  },
};
</script>

<style lang="scss" scoped>
</style>